import { getTreatmentsExtensionForGraphqlBody } from '@ms/yammer-data/dist/api';
import { acquireToken } from '@ms/yammer-data/dist/authentication';
import { getClientForwardExperiments } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { Store } from '@ms/yammer-data/dist/state/types';
import { getCurrentLocale } from '@ms/yammer-i18n-react';
import type { LazyRelayAppWrapperProps } from '@ms/yammer-relay/dist/environment';
import { YammerTeamsState } from 'state/types';

import config from '../../bootstrap/config';

export const getLazyRelayAppWrapperProps = (
  store: Store<YammerTeamsState>,
  etag?: string
): LazyRelayAppWrapperProps => {
  const state = store.getState();

  const experiments = getClientForwardExperiments(state);
  const treatments = getTreatmentsExtensionForGraphqlBody({
    state,
    experiments,
  });

  const relay = {
    authScope: config.adal.resources.yammer,
    host: config.hosts.graphql,
    treatments,
    etag,
  };
  const loki = {
    acquireToken: () => acquireToken([config.adal.resources.loki]),
    clientType: config.loki.clientType,
    region: config.loki.region,
  };
  const currentLocale = getCurrentLocale(state);

  return {
    loki,
    relay,
    currentLocale,
  };
};
